<template lang="pug">
.track-delivery-button(v-if="canTrack")
  shActionButton(
    :action="fetchTracking"
    text="Rastrear"
    textRunning="Rastreando"
    :mini="true"
    :normalColor="true"
  )

  DeliveryTrackingModal(
    :show="showModal"
    :tracking="tracking"
    :events="trackingEvents"
    :error="trackingError"
    @close="showModal = false"
  )
</template>

<script>
import gql from '@my/graphql'
import gqlCoordinadora from '@/graphql/coordinadora'
import gqlWelivery from '@/graphql/welivery'
import shActionButton from '@/components/elements/ActionButton.vue'
import DeliveryTrackingModal from '@/components/elements/delivery/DeliveryTrackingModal.vue'

export default {
  name: 'TrackDeliveryButton',

  components: {
    shActionButton,
    DeliveryTrackingModal
  },

  props: {
    tracking: {
      type: String,
      default: ''
    },
    conveyor: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      showModal: false,
      trackingEvents: [],
      trackingError: ''
    }
  },

  computed: {
    canTrack () {
      return !!(this.tracking && String(this.tracking).trim() && ['coordinadora', 'welivery'].includes(this.conveyor))
    }
  },

  methods: {
    async fetchTracking () {
      this.trackingError = ''
      this.trackingEvents = []

      const isWelivery = this.conveyor === 'welivery'
      const response = await gql.query(
        isWelivery ? gqlWelivery.GET_TRACKING_WELIVERY : gqlCoordinadora.GET_TRACKING_COORDINADORA,
        { tracking: String(this.tracking).trim() },
        false,
        true,
        true
      )

      if (response.error) {
        this.trackingError = response.error
      } else {
        this.trackingEvents = (response.data && response.data[isWelivery ? 'getTrackingWelivery' : 'getTrackingCoordinadora']) || []
      }

      this.showModal = true
      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
.track-delivery-button
  display inline-flex
  align-items center
  margin-left .5rem
</style>



// WEBPACK FOOTER //
// src/components/elements/delivery/TrackDeliveryButton.vue